import { ListTodo, Luggage } from "lucide-react";
import { normalizeListKind, type ListKind } from "@checklist/shared";

export function KindChip({
  kind,
  className,
}: {
  kind: ListKind | string;
  className?: string;
}) {
  const packing = normalizeListKind(kind) === "packing";
  const Icon = packing ? Luggage : ListTodo;
  const label = packing ? "Packing" : "To-do";
  return (
    <span
      className={[
        "inline-flex shrink-0 items-center gap-1 rounded-md border border-line bg-slate-50 px-1.5 py-0.5 text-xs font-medium text-muted-sm",
        className ?? "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <Icon size={12} aria-hidden="true" />
      {label}
    </span>
  );
}
